// Frontend plugin registry.
// Each plugin exposes { id, flagKey, routes:[{path, Component}], nav:[{...navItem, afterPath, flagKey}] }.
//
// To ADD a plugin:    import it here and add it to the PLUGINS array.
// To REMOVE a plugin: delete its folder and remove it from the PLUGINS array below.
// App.js consumes `pluginRoutes`; Layout.jsx consumes `pluginNavItems`.
import eventsPlugin from './events';

export const PLUGINS = [
  eventsPlugin,
];

export const pluginRoutes = PLUGINS.flatMap((p) =>
  (p.routes || []).map((r) => ({ ...r, pluginId: p.id }))
);

export const pluginNavItems = PLUGINS.flatMap((p) =>
  (p.nav || []).map((n) => ({ ...n, pluginId: p.id }))
);
